"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../elements/Button"));
const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 5px',
    },
    workspaceName: {
        flex: '1',
        textAlign: 'left',
        fontSize: '11px',
        padding: '5px',
    },
    workspaceVersion: {
        fontSize: '9px',
        padding: '5px',
    },
    readOnly: {
        fontSize: '9px',
        padding: '0 5px',
        border: '1px solid #00d5ff',
        borderRadius: '10px',
    },
    newContainer: {
        backgroundColor: '#f6f6f6',
        display: 'flex',
        padding: '0.3em',
    },
    input: {
        padding: '0.5em 0.8em',
        fontSize: '12px',
        color: 'black',
        outline: 'none',
        backgroundColor: 'transparent',
        flex: 1,
    },
};
function WorkspaceItem({ item, onSave, onDelete }) {
    const [name, setName] = (0, react_1.useState)('');
    // Add new workspace
    function addHandler(e) {
        e.stopPropagation();
        setName('');
        onSave?.(name);
    }
    // bubble onDelete
    function deleteHandler(e) {
        e.stopPropagation();
        onDelete?.(item.key);
    }
    function onTextChange(e) {
        setName(e.target.value);
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: item.key === 'new' ? ((0, jsx_runtime_1.jsxs)("div", { style: styles.newContainer, children: [(0, jsx_runtime_1.jsx)("input", { style: styles.input, value: name, placeholder: "Custom workspace", onClick: (e) => e.stopPropagation(), onChange: onTextChange }), (0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: addHandler, disabled: !name, style: { fontSize: '11px' }, children: "Save" })] })) : ((0, jsx_runtime_1.jsxs)("div", { style: styles.container, children: [(0, jsx_runtime_1.jsx)(WorkSpaceIndicator, { source: item.source }), (0, jsx_runtime_1.jsx)("span", { style: styles.workspaceName, children: item.label }), item.source !== 'user' && ((0, jsx_runtime_1.jsx)("span", { style: styles.readOnly, children: "Read Only" })), item.source === 'user' && onDelete && ((0, jsx_runtime_1.jsx)(Button_1.default.Danger, { onClick: deleteHandler, size: "xSmall", fill: "clear", children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, {}) })), item.version && !item.isReadOnly && ((0, jsx_runtime_1.jsxs)("span", { style: styles.workspaceVersion, children: ["V", item.version] }))] })) }));
}
const style = {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};
const WorkSpaceIndicator = (props) => {
    let letter = '';
    let backgroundColor = 'red';
    switch (props.source) {
        case 'predefined':
            letter = 'P';
            backgroundColor = '#2dd36f';
            break;
        case 'custom':
            letter = 'C';
            backgroundColor = '#ffbe05';
            break;
        case 'component':
            letter = 'NC';
            backgroundColor = '#cccccc';
            break;
        case 'nmriumFile':
            letter = 'NF';
            backgroundColor = '#cccccc';
            break;
        case 'user':
            letter = 'U';
            backgroundColor = '#ff6f00';
            break;
        default:
            break;
    }
    return ((0, jsx_runtime_1.jsx)("div", { style: { ...style, backgroundColor }, children: (0, jsx_runtime_1.jsx)("span", { style: { fontWeight: 'bolder' }, children: letter }) }));
};
exports.default = WorkspaceItem;
